import {
  FETCH_COURSE_DATA,
  FETCH_CHAPTERS_DATA,
  FETCH_LESSIONS_DATA,
  SHOW_SIDEBAR,
  SHOW_BACK_SCREEN,
  SHOW_CHAPTERS,
  OPEN_QA_MODAL_LESSON,
  FETCH_LESSON_LIVEQA_DATA,
  OPEN_QUIZ_MODAL_LESSON,
  FETCH_DYNAMIC_FORM_RESPONSE_DATA,
  FETCH_COURSE_DATA_BY_USER_ACCESS
} from '../actions';

export function CourseDataReducers(state = {}, action) {
  switch (action.type) {
    case FETCH_COURSE_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function showSidebarReducer(state = {}, action) {
  if (action.type === SHOW_SIDEBAR) {
    return action.payload;
  }
  return state;
}

export function chaptersDataReducer(state = {}, action) {
  if (action.type === FETCH_CHAPTERS_DATA) {
    return action.payload;
  }
  return state;
}

export function lessionsDataReducer(state = {}, action) {
  if (action.type === FETCH_LESSIONS_DATA) {
    return action.payload;
  }
  return state;
}

export function showBackScreenReducerKochify(state = {}, action) {
  if (action.type === SHOW_BACK_SCREEN) {
    return action.payload;
  }
  return state;
}

export function showChaptersReducer(state = false, action) {
  if (action.type === SHOW_CHAPTERS) {
    return action.payload;
  }
  return state;
}

export function lessonqaDataReducer(state = {}, action) {
  if (action.type === FETCH_LESSON_LIVEQA_DATA) {
    return action.payload;
  }
  return state;
}

export function openqaModalReducer_lesson(state = false, action) {
  if (action.type === OPEN_QA_MODAL_LESSON) {
    return action.payload;
  }
  return state;
}

export function openQuizModalReducer_lesson(state = {}, action) {
  if (action.type === OPEN_QUIZ_MODAL_LESSON) {
    return action.payload;
  }
  return state;
}

export function dynamicFormDataReducer(state = {}, action) {
  if (action.type === FETCH_DYNAMIC_FORM_RESPONSE_DATA) {
    return action.payload;
  }
  return state;
}

export function CourseDataReducers_ByUserAccess(state = {}, action) {
  switch (action.type) {
    case FETCH_COURSE_DATA_BY_USER_ACCESS:
      return action.payload;
    default:
      return state;
  }
}
